module.exports = __webpack_public_path__ + "static/media/employee_active_icon.d3f3f4ba.svg";